import { createPulseBlazorIframeController, createPulseBlazorIframeState } from '~/utils/pulseBlazorIframeController'
import type { PulseMessengerModule } from '~/utils/pulseBlazorIframeController'
import { resolvePulseBlazorBaseUrl } from '~/utils/pbAccountIframeFeature'

declare function useErrorLogger (): { logError: (error: unknown, context?: Record<string, unknown>) => void }

const moduleState = createPulseBlazorIframeState()

async function loadCrossWinMessengerModule (): Promise<PulseMessengerModule> {
  const module = await import('~/utils/CrossWinMessengerService')
  return module as PulseMessengerModule
}

/**
 * Prefer `typeof window` over `import.meta.client` so Playwright unit tests can import this module.
 */
const isPulseClient = (): boolean => typeof window !== 'undefined'

export const usePulseBlazorIframe = () => {
  const { logError } = useErrorLogger()
  const runtimeConfig = useRuntimeConfig()

  return createPulseBlazorIframeController(
    {
      logError,
      isClient: isPulseClient,
      loadMessengerModule: loadCrossWinMessengerModule,
      getPathname: () => globalThis.window?.location?.pathname ?? '',
      pulseBlazorBaseUrl: resolvePulseBlazorBaseUrl(runtimeConfig?.public)
    },
    moduleState
  )
}
